import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { handleFetchCustomerCount } from "../../../../api/customers";
import formatMoney from "../../../../utils/formatMoney";
import logo from "../../../../assets/images/logo200.png";

export default function AllBusinesses({ businessId }: any) {
  const { data: businesses } = useQuery({
    queryKey: ["businesses"],
    queryFn: () => handleFetchCustomerCount({}),
  });

  const getTotalCount = () => {
    let total = 0;
    businesses?.forEach((business: any) => {
      total += business.customerCount;
    });
    return total;
  };

  useEffect(() => {}, [businessId]);
  if (!businesses) return <div></div>;

  return (
    <div className="grid grid-cols-12 gap-1">
      <Link
        to={`/customers`}
        className={`col-span-6 sm:col-span-2 border  p-4 ${
          businessId === null ? "border-blue-200 bg-blue-50" : ""
        }`}
      >
        <div className="flex justify-between">
          <div className="flex">
            <img src={logo} width={80} alt="" />
            <div className="mx-2">
              <div className="">All Customers</div>
              <div className="">Group</div>
            </div>
          </div>

          <div className="text-sm">{formatMoney(getTotalCount())}</div>
        </div>
      </Link>
      {businesses?.map((business: any, index: number) => (
        <Link
          to={`/customers?id=${business?._id}&companyNo=${business?.businessDetails?.companyNo}`}
          key={index}
          className={`col-span-6 sm:col-span-2 border  p-4 ${
            businessId === business?._id ? "border-blue-200 bg-blue-50" : ""
          }`}
        >
          <div className="flex justify-between">
            <div className="">
              <img
                src={business?.businessDetails?.logo}
                width={180}
                height={40}
                alt=""
              />
            </div>

            <div className="text-sm ">
              <div className="font-bold text-end">
                {formatMoney(business.customerCount)}
              </div>
              <div className="flex text-xxs justify-end">
                Co. {business?.businessDetails?.companyNo}
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
